<template>
  <div>
    <CustomModal 
    :title="'AJOUTER UNE ADRESSE'"
    :open="add_address"
    @close-modal="add_address = false, validate = false">
      <template slot="modal_content">
        <AddressForm @complete="validate = false, add_address = false" :form_type="'add'" :validate="getValidate" />
      </template>
      <template slot="modal_footer">
        <button class="btn" @click="validate = true">{{$_('validate').toUpperCase()}}</button>
      </template>
    </CustomModal>

    <h3>{{$_('my_delivery_address')}}</h3>
    <div class="customer-address-list">   
      <div class="grid-row">
        <div class="c-4 c-xs-12 c-sm-12 c-md-6 c-lg-4" v-for="(customer, index) in getCustomerAddressL" :key="index">

          <Address :mode="mode" :address_info="customer" :index="index" :length="getCustomerAddressL.length" :selectedL="getLastAddrL" />

        </div>
        <div class="c-6 c-xs-12 c-sm-12 c-md-6 c-lg-4">
          <div class="add-address" @click="add_address = true ">
            <span><i class="material-icons">add</i></span>
          </div>
        </div>
      </div>
    </div>           
    <h3>{{$_('my_billing_address')}}</h3>
    <div class="customer-address-list">   
      <div class="grid-row">
        <div class="c-6 c-xs-12 c-sm-12 c-md-6 c-lg-4" v-for="(customer, index) in getCustomerAddressF" :key="index">
          <Address :mode="mode" :address_info="customer" :index="index" :length="getCustomerAddressL.length" :selectedF="getLastAddrF" />
        </div>
      </div>
    </div>              
  </div>
</template>

<script>

import customerService from '@/modules/client/services/customerService';
import Address from '@/modules/client/components/Address';
import CustomModal from '@/common/components/widget/Modal/CustomModal';
import AddressForm from '@/modules/client/components/AddressForm';

export default {
  name: 'CustomerAddress',
  components: {
    Address,
    CustomModal,
    AddressForm
  },
  props: {
    mode: {
      type: String,
      default: 'cart'
    },
    pnocl: {
      type: Number,
      default: -1
    }
  },
  data() {
    return {
      add_address: false,
      validate: false
    }
  },
  created() {

    let pnocl = null;

    if(this.$props.pnocl !== 0 && this.$props.pnocl !== -1) {
      pnocl = this.$props.pnocl;
    }

    customerService.getCustomerAddress('echantillon', pnocl)
    .then(res => {
      if(res.data.DS_O !== undefined) {
        this.$store.dispatch('client/SET', {key: 'address', value: res.data.DS_O.OUT});
      }
    })

    // if(ttyp_adr === 'L') {
    //   this.$store.dispatch("echantillon/SET_HEADER", { key: 'tadr1l', value: this.$props.address_info.TADR1 });
    //   this.$store.dispatch("echantillon/SET_HEADER", { key: 'tadr2l', value: this.$props.address_info.TADR2 });
    //   this.$store.dispatch("echantillon/SET_HEADER", { key: 'tadr3l', value: this.$props.address_info.TADR3 });
    //   this.$store.dispatch("echantillon/SET_HEADER", { key: 'tcpostl', value: this.$props.address_info.TCPOST });
    //   this.$store.dispatch("echantillon/SET_HEADER", { key: 'tvillel', value: this.$props.address_info.TVILLE });
    //   this.$store.dispatch("echantillon/SET_HEADER", { key: 'tcpaysl', value: this.$props.address_info.TLPAYS });
    //   this.$store.dispatch("echantillon/SET_HEADER", { key: 'tcprovl', value: this.$props.address_info.TLPROV });
    // }
  },
  computed: {
    getCustomerAddressL() {
      return  this.$store.getters['client/get_address'].filter(item => {
        return item.TTYP_ADR === 'L';
      });
    },
    getCustomerAddressF() {
     return this.$store.getters['client/get_address'].filter(item => {
        return item.TTYP_ADR === 'F';
      });
    },
    getLastAddrL() {
      return this.$store.getters['panier/get_last_selected_addr_l'];
    },
    getLastAddrF() {
      return this.$store.getters['panier/get_last_selected_addr_f'];
    },
    getNew() {
      return this.add_address;
    },
    getValidate() {
      return this.validate;
    },
  },
}
</script>

<style scoped>
.customer-address-list {
  display: flex;
  align-items: flex-start;
}
.add-address {
  border: solid 1px #e9e9e9;
  border-radius: 8px;
  height: 250px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all .3s;
}
.add-address:hover {
  border: solid 1px #c4c4c4;
  cursor: pointer;
}
.add-address:hover i {
  color: #c4c4c4;
}
.add-address i {
  font-size: 10rem;
  color: #e9e9e9;
  transition: all .3s;
}
</style>